import Search from '@mui/icons-material/Search'
import { TextField, BaseTextFieldProps, InputAdornment } from '@mui/material'
import { ChangeEvent, FC } from 'react'
import { IReactFormHookProps } from 'src/models/interfaces/lib/ReactFormHook'

interface IProps extends BaseTextFieldProps, IReactFormHookProps {
  onChange?: (value: string) => void
  InputProps?: any
}

const TextFieldUiKit: FC<IProps> = ({ register, onChange, validation, name, InputProps, ...props }) => {
  const registerProps = register && name && register(name, validation)
  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e.target.value)
  }
  // console.log(props);
  

  return (
    <TextField
      size="small"
      className="w-full"
      // fullWidth
      {...props}
      {...registerProps}
      InputProps={InputProps}
      onChange={onChangeHandler}
    />
  )
}

export default TextFieldUiKit

// endAdornment: (
//   <InputAdornment position="start">
//     <AccountCircle />
//   </InputAdornment>
// ),
